/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export enum CREATE {
	OPEN = "viewEditor.createPage.open"
}

export enum EDIT {
	OPEN_MAIN_VIEW = "viewEditor.edit.openMainView",
	TOGGLE_LEFT_PANEL = "viewEditor.edit.toggleLeftPanel",
	TOGGLE_RIGHT_PANEL = "viewEditor.edit.toggleRightPanel",
	HIDE_ALL_PANELS = "viewEditor.edit.hideAllPanels",
	TOGGLE_CONSOLE = "viewEditor.edit.toggleConsole",
	SAVE_RESOURCE = "viewEditor.edit.saveResource",
	OPEN_HISTORY = "viewEditor.edit.openHistory",
	DELETE_SELECTION = "viewEditor.edit.deleteSelection",
	UNSELECT_ALL = "viewEditor.edit.unselectAll",
	COPY = "viewEditor.edit.copy",
	PASTE = "viewEditor.edit.paste",
	UNDO = "viewEditor.edit.undo",
	REDO = "viewEditor.edit.redo"
}
